import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'
import {
  SUPPORT_EMAIL,
  PRIVACY_EMAIL,
  COMPANY_NAME,
  BRAND_NAME,
  WEBSITE_URL,
  SUPPORT_PHONE,
  SUPPORT_PHONE_TEL,
  COMPANY_LEGAL_FORM,
  COMPANY_CAPITAL,
  COMPANY_RCS,
  COMPANY_TAHITI_NUMBER,
  COMPANY_ADDRESS_LINE1,
  COMPANY_ADDRESS_LINE2,
  COMPANY_DIRECTOR,
  HOSTING_PROVIDER,
} from '../constants/contact'
import { Logo } from '../components/Logo'

export default function LegalNotice() {
  const { user } = useAuth()

  return (
    <div className="min-h-screen bg-paybyphone-light">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200 px-4 py-3">
        <div className="max-w-4xl mx-auto flex items-center justify-between">
          <Link to={user ? '/dashboard' : '/'} className="flex items-center">
            <Logo width={150} height={36} />
          </Link>
          {user && (
            <Link to="/dashboard" className="text-paybyphone-green hover:text-paybyphone-green/80">
              ← Back to Dashboard
            </Link>
          )}
        </div>
      </header>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 py-8">
        <div className="bg-white rounded-lg shadow-sm p-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-8">Legal Notice / Mentions légales</h1>

          <div className="prose prose-lg max-w-none">
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">English version</h2>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Website publisher</h2>
              <div className="bg-gray-50 p-4 rounded-lg mb-4">
                <p className="text-gray-700">
                  The website {WEBSITE_URL} (operated under the trade name “{BRAND_NAME}”) is published by:
                </p>
                <p className="text-gray-700 mt-3">
                  <strong>NEXIAMOBILE</strong><br />
                  {COMPANY_LEGAL_FORM}<br />
                  Share capital: {COMPANY_CAPITAL}<br />
                  Registration: {COMPANY_RCS} — {COMPANY_TAHITI_NUMBER}<br />
                  Registered office: {COMPANY_ADDRESS_LINE1}, {COMPANY_ADDRESS_LINE2}
                </p>
              </div>
              <p className="text-gray-700 mb-4">
                <strong>Publication director:</strong> {COMPANY_DIRECTOR}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Contact</h2>
              <p className="text-gray-700 mb-2">
                Customer support: <a href={`mailto:${SUPPORT_EMAIL}`} className="text-paybyphone-green hover:text-green-600 font-medium">{SUPPORT_EMAIL}</a>
                {' '}— Phone: <a href={`tel:${SUPPORT_PHONE_TEL}`} className="text-paybyphone-green hover:text-green-600 font-medium">{SUPPORT_PHONE}</a>
              </p>
              <p className="text-gray-700 mb-2">
                Privacy requests: <a href={`mailto:${PRIVACY_EMAIL}`} className="text-paybyphone-green hover:text-green-600 font-medium">{PRIVACY_EMAIL}</a>
              </p>
              <p className="text-gray-700 mb-4">
                Contact form: <Link to="/contact" className="text-paybyphone-green hover:text-green-600 font-medium">{WEBSITE_URL}/contact</Link>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Hosting provider</h2>
              <p className="text-gray-700 mb-4">{HOSTING_PROVIDER}</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Intellectual property</h2>
              <p className="text-gray-700 mb-4">
                The entire content of this website (texts, graphics, logos, trademarks, software) is the property of {COMPANY_NAME} or
                its licensors and is protected by intellectual property laws. Any reproduction without prior written authorization is prohibited.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Other legal documents</h2>
              <p className="text-gray-700 mb-4">
                <Link to="/terms" className="text-paybyphone-green hover:text-green-600 font-medium">Terms and Conditions</Link>{' — '}
                <Link to="/privacy" className="text-paybyphone-green hover:text-green-600 font-medium">Privacy Policy</Link>{' — '}
                <Link to="/contact" className="text-paybyphone-green hover:text-green-600 font-medium">Contact</Link>
              </p>
            </section>

            <hr className="my-10" />

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">Version française</h2>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Éditeur du site</h2>
              <div className="bg-gray-50 p-4 rounded-lg mb-4">
                <p className="text-gray-700">
                  Le site {WEBSITE_URL} (exploité sous la marque « {BRAND_NAME} ») est édité par :
                </p>
                <p className="text-gray-700 mt-3">
                  <strong>NEXIAMOBILE</strong><br />
                  {COMPANY_LEGAL_FORM}<br />
                  Capital social : {COMPANY_CAPITAL}<br />
                  Immatriculation : {COMPANY_RCS} — {COMPANY_TAHITI_NUMBER}<br />
                  Siège social : {COMPANY_ADDRESS_LINE1}, 98701 Arue, Polynésie française
                </p>
              </div>
              <p className="text-gray-700 mb-4">
                <strong>Directeur de la publication :</strong> {COMPANY_DIRECTOR}
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. Contact</h2>
              <p className="text-gray-700 mb-2">
                Support client : <a href={`mailto:${SUPPORT_EMAIL}`} className="text-paybyphone-green hover:text-green-600 font-medium">{SUPPORT_EMAIL}</a>
                {' '}— Téléphone : <a href={`tel:${SUPPORT_PHONE_TEL}`} className="text-paybyphone-green hover:text-green-600 font-medium">{SUPPORT_PHONE}</a>
              </p>
              <p className="text-gray-700 mb-2">
                Données personnelles : <a href={`mailto:${PRIVACY_EMAIL}`} className="text-paybyphone-green hover:text-green-600 font-medium">{PRIVACY_EMAIL}</a>
              </p>
              <p className="text-gray-700 mb-4">
                Formulaire de contact : <Link to="/contact" className="text-paybyphone-green hover:text-green-600 font-medium">{WEBSITE_URL}/contact</Link>
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Hébergeur</h2>
              <p className="text-gray-700 mb-4">{HOSTING_PROVIDER}</p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Propriété intellectuelle</h2>
              <p className="text-gray-700 mb-4">
                L'ensemble du contenu de ce site (textes, graphismes, logos, marques, logiciels) est la propriété de {COMPANY_NAME} ou de
                ses concédants et est protégé par le droit de la propriété intellectuelle. Toute reproduction sans autorisation écrite
                préalable est interdite.
              </p>
            </section>

            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Autres documents légaux</h2>
              <p className="text-gray-700 mb-4">
                <Link to="/terms" className="text-paybyphone-green hover:text-green-600 font-medium">Conditions Générales de Vente</Link>{' — '}
                <Link to="/privacy" className="text-paybyphone-green hover:text-green-600 font-medium">Politique de confidentialité</Link>{' — '}
                <Link to="/contact" className="text-paybyphone-green hover:text-green-600 font-medium">Contact</Link>
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  )
}
